import { prop, join, without, values, contains } from 'ramda';
import { createSelector } from 'reselect';
import { getIsPublicApiV1 } from './settings';

export const getLocation = prop('location');
export const getPosition = createSelector(
  getLocation,
  getIsPublicApiV1,
  (location, isApiPublicV1) => (isApiPublicV1 ? location?.position : location?.location),
);
export const getLocationDetails = createSelector(
  getLocation,
  prop('locationDetails'),
);
export const getHighway = createSelector(
  getLocation,
  getLocationDetails,
  getIsPublicApiV1,
  (location, locationDetails, isApiPublicV1) => {
    if (isApiPublicV1) return location?.highway;
    return locationDetails?.highway;
  },
);
export const getCoveredGarage = createSelector(
  getLocation,
  getLocationDetails,
  getIsPublicApiV1,
  (location, locationDetails, isApiPublicV1) => {
    if (isApiPublicV1) return location?.coveredGarage;
    return locationDetails?.coveredGarage;
  },
);
export const getAddress = createSelector(
  getLocation,
  prop('address'),
);
export const getCountry = createSelector(
  getAddress,
  prop('country'),
);
export const getHighwayLocation = createSelector(
  getLocationDetails,
  prop('highwayLocation'),
);
export const getHighwayLocationV1 = createSelector(
  getLocation,
  prop('highwayLocation'),
);
export const getHighwayMetres = createSelector(
  getHighwayLocation,
  getHighwayLocationV1,
  getIsPublicApiV1,
  (highwayLocationV0, highwayLocationV1, isApiPublicV1) => {
    if (isApiPublicV1) return highwayLocationV1?.milestone;
    return highwayLocationV0?.metres;
  },
);

export const getIsCountryHighwaySectionAllowed = createSelector(
  getCountry,
  country => contains(country, ['IT', 'ES', 'PT', 'DE']),
);

export const getFormatedAddress = createSelector(
  getAddress,
  address => join(' ', without([undefined], values(address))),
);
